/**
 * Aceitar um item sem prova (`TP-058`, `D9`): o item continua sem prova e o motivo fica no histórico com o nome de quem
 * aceitou. Serve ao resumo "O que falta" (itens do cadastro) e ao item do passo, no cartão da frente.
 */

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { ErroDaApi } from '../../../shared/api/erros';
import { aceitarSemProva, chavesDeCompletude, invalidarOQueAProvaMuda } from './api';

export function AceiteSemProva({ casoId, chave }: { casoId: string; chave: string }): React.JSX.Element {
  const cliente = useQueryClient();
  const [aberto, setAberto] = useState(false);
  const [motivo, setMotivo] = useState('');
  const aceitar = useMutation({
    mutationFn: () => aceitarSemProva(casoId, chave, motivo.trim()),
    onSuccess: (atualizada) => {
      cliente.setQueryData(chavesDeCompletude.doCaso(casoId), atualizada);
      void invalidarOQueAProvaMuda(cliente, casoId, 'completude');
      setAberto(false);
      setMotivo('');
    },
  });

  if (!aberto) {
    return (
      <button
        type="button"
        className="cursor-pointer border-0 bg-transparent p-0 text-[0.75rem] text-[var(--tinta-2)] underline decoration-dotted"
        onClick={() => {
          setAberto(true);
        }}
      >
        Aceitar sem prova
      </button>
    );
  }

  return (
    <div className="mt-1 flex flex-wrap items-center gap-2">
      <TextField
        size="small"
        autoFocus
        label="Motivo"
        value={motivo}
        onChange={(e) => {
          setMotivo(e.target.value);
        }}
        sx={{ flex: '1 1 14rem' }}
      />
      <Button
        variant="outlined"
        size="small"
        disabled={aceitar.isPending || motivo.trim() === ''}
        onClick={() => {
          aceitar.mutate();
        }}
      >
        Aceitar sem prova
      </Button>
      <Button
        variant="text"
        size="small"
        onClick={() => {
          setAberto(false);
          setMotivo('');
        }}
      >
        Cancelar
      </Button>
      {aceitar.isError && (
        <p role="alert" className="m-0 w-full text-[0.75rem] text-[var(--roxo)]">
          {aceitar.error instanceof ErroDaApi ? aceitar.error.message : 'Não foi possível aceitar. Tente novamente.'}
        </p>
      )}
    </div>
  );
}
